/* import __COLOCATED_TEMPLATE__ from './goal-success-table-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();